import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import {
  Box
} from "@biome-design-system/ui/Box";
import { DefaultQuestionStep } from "./DefaultQuestionStep.js";
import { useFilterWizardContext } from "./FilterWizardContext.js";
const Question = styled(Box, {
  name: "MuiFilterWizard",
  slot: "question"
})(() => ({}));
const FilterWizardQuestionStepInner = ({
  component = "fieldset",
  children,
  labels,
  ...restProps
}, ref) => {
  const { currentStep } = useFilterWizardContext();
  return /* @__PURE__ */ jsx(
    Question,
    {
      "data-step": currentStep,
      "data-testid": "filter-wizard-question",
      ...restProps,
      component,
      ref,
      children: children ?? /* @__PURE__ */ jsx(DefaultQuestionStep, { labels })
    }
  );
};
const FilterWizardQuestionStep = forwardRef(
  FilterWizardQuestionStepInner
);
export {
  FilterWizardQuestionStep
};
